/**
 * 採用ページ 追従背景動画 SP/PC 切り替え
 * mediaクエリの初期評価をJSで行うことでブラウザ依存差をなくす
 */
const recruitBgVideo = () => {
    const video = document.querySelector('.pg-recruit__bg-video');
    if (!video) return;

    const srcSp = video.dataset.srcSp;
    const srcPc = video.dataset.srcPc;

    const mq = window.matchMedia('(max-width: 1024px)');

    const switchSrc = (isSp) => {
        const newSrc = isSp ? srcSp : srcPc;
        if (video.currentSrc && video.currentSrc.endsWith(newSrc)) return;
        video.src = newSrc;
        video.load();
        video.play().catch(() => {});
    };

    mq.addEventListener('change', (e) => switchSrc(e.matches));
    switchSrc(mq.matches);
};

export default recruitBgVideo;
